import { useEffect } from 'react';

export default function GalleryLightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  useEffect(() => {
    if (currentIndex === null) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [currentIndex, onClose, onPrev, onNext]);

  if (currentIndex === null || !images || images.length === 0) return null;

  const currentImage = images[currentIndex];

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 backdrop-blur-md flex items-center justify-center p-4 sm:p-6 animate-in fade-in duration-200"
      onClick={onClose}
    >
      {/* Top controls */}
      <div className="absolute top-4 right-4 z-50 flex items-center gap-3">
        <span className="text-gray-300 text-xs font-medium px-3 py-1 bg-white/10 rounded-full">
          {currentIndex + 1} / {images.length}
        </span>
        <button
          type="button"
          onClick={onClose}
          className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-white"
          aria-label="Luk billede"
        >
          <i className="fa-solid fa-xmark text-lg" />
        </button>
      </div>

      {/* Prev button */}
      {images.length > 1 && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onPrev();
          }}
          className="absolute left-4 z-50 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-white"
          aria-label="Forrige billede"
        >
          <i className="fa-solid fa-chevron-left text-lg" />
        </button>
      )}

      {/* Image Container */}
      <div
        className="max-w-5xl max-h-[85vh] flex flex-col items-center justify-center relative"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={currentImage.src || currentImage.image_url?.[0] || currentImage.url}
          alt={currentImage.alt || currentImage.title || 'Maler Carsten Janum projekt'}
          className="max-w-full max-h-[75vh] object-contain rounded-lg shadow-2xl"
        />
        {(currentImage.alt || currentImage.title) && (
          <p className="mt-3 text-center text-gray-200 text-sm font-medium max-w-2xl px-4">
            {currentImage.title || currentImage.alt}
          </p>
        )}
      </div>

      {/* Next button */}
      {images.length > 1 && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
          className="absolute right-4 z-50 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-white"
          aria-label="Næste billede"
        >
          <i className="fa-solid fa-chevron-right text-lg" />
        </button>
      )}
    </div>
  );
}
